import React from 'react';
import classNames from 'classnames';
import { useStepperContext } from './StepperContext';
import styles from './Stepper.module.scss';

export type StepperNumberProps = {
  number?: number;
  state?: 'active' | 'done' | 'disabled';
  label?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  description?: string;
};

export function StepperNumber({ label, state, number }: StepperNumberProps) {
  const { steps } = useStepperContext();

  return (
    <div className={styles.stepContNumberLabel}>
      <div className={styles.stepContNumber}>
        <div
          className={classNames(styles.stepLine, {
            [styles.stepLineVisible]: number !== 1,
            [styles.stepLineInvisible]: number === 1,
          })}
        />

        <div
          className={classNames(styles.stepNumber, {
            [styles.stepNumberActive]: state === 'active',
            [styles.stepNumberDone]: state === 'done',
            [styles.stepNumberDisabled]: state === 'disabled',
          })}
        >
          {state === 'done' ? (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#ffffff" />
            </svg>
          ) : (
            <span>{number}</span>
          )}
        </div>

        <div
          className={classNames(styles.stepLine, {
            [styles.stepLineVisible]: (number ?? 0) < steps,
            [styles.stepLineInvisible]: (number ?? 0) >= steps,
          })}
        />
      </div>
      <p
        className={classNames(styles.stepLabel, {
          [styles.stepLabelActive]: state === 'active',
          [styles.stepLabelDone]: state === 'done',
          [styles.stepLabelDisabled]: state === 'disabled',
        })}
      >
        {label}
      </p>
    </div>
  );
}
